import * as React from "react"

import { cn } from "src/utils/cn"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      // Matches the Input primitive's language (xl radius, muted fill) with a
      // min-height instead of a fixed one so it can grow.
      "flex min-h-[100px] w-full rounded-xl border border-input bg-muted/50 px-4 py-3 text-base transition-colors placeholder:text-muted-foreground focus-visible:border-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      className
    )}
    {...props}
  />
))
Textarea.displayName = "Textarea"

export { Textarea }
